<app-drag-drop
  [dragStart]="OnDragStart.bind(this)"
  [drop]="OnDrop.bind(this)"
  [dragOver]="OnDragOver.bind(this)"
  >
  <div class="row gutter-10">
    @for (item of tasks; track item) {
      <div [class]="itemClass">
        <div
          class="task-card-chromium"
          [ngStyle]="GetSelectedStyle(item)"
          data-draggable="item"
          draggable="true"
          aria-grabbed="false"
          (mouseup)="OnSelectTask($event, item)"
          (dragstart)="OnSelectTask($event, item)"
          >
          <ng-container
          *ngTemplateOutlet="
            taskDragDropListItemTemplate
              ? taskDragDropListItemTemplate
              : defaultItemTemplate;
            context: { item: item }
          "
          ></ng-container>
        </div>
      </div>
    }
  </div>
</app-drag-drop>

<ng-template #defaultItemTemplate let-item="item"
  >{{ item.taskNoDisplay }}: {{ item.label }}</ng-template
  >
